import React from 'react';
import { Modal, Button, Group, Box, Flex } from '@mantine/core';

type DeleteConfirmationModalProps = {
    dialogVisible: boolean;
    dialogHandlers: {
        close: () => void;
    };
    onConfirm: () => void;
    message: string
    isDeleting?: boolean
};

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ dialogVisible, dialogHandlers, onConfirm, message, isDeleting }) => {

    return (
        <Modal
            size="md"
            opened={dialogVisible}
            onClose={() => {
                dialogHandlers.close();
            }}
            title='Confirm deletion'
            centered
        >
            <Flex>
                <Box>
                    <p style={{ whiteSpace: 'pre-line' }}>{message}</p>
                </Box>
            </Flex>
            <Group justify="flex-end" mt="md">
                <Button variant="filled" className='cancel-button-delete-confirmation' color="gray" onClick={() => { dialogHandlers.close() }}>Cancel</Button>
                <Button onClick={() => { onConfirm(); dialogHandlers.close(); }} color="red" loading={isDeleting}>
                    Delete
                </Button>
            </Group>
        </Modal>
    );
};

export default DeleteConfirmationModal;
